import { PlannedDemandPageThemeSizeConfig } from './types';

const large: PlannedDemandPageThemeSizeConfig = {
  plannedDemandPage: {},
};

export default large;
